import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkGetHospitalCounters } from '../types';

const onGetHospitalCounters: IThunkGetHospitalCounters = thunk(
  // @ts-ignore
  async ({ setHospitalCounters }, filters) => {
    const data = await api.hospital.getCounters(filters).then(res => res.data);

    setHospitalCounters(data ?? null);
  },
);

export default onGetHospitalCounters;
